import React, { Component } from 'react';
import { VirtualizedList } from 'react-native';
import { isWeb } from 'core';

class List extends Component {
  _onStartReachedThreshold = 0.5;
  _onScrollAtZeroThreshold = 3;
  _scrollEventThrottle = isWeb ? 1000 : 0;
  // listRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    data !== prevProps.data && (this.hasDataChangedSinceStartReached = true) && (this.hasDataChangedSinceScrollAtZero = true);
  }

  _maybeCallOnStartReached = e => {
    const { onStartReached, onStartReachedThreshold } = this.props;
    const onStartThreshold = onStartReachedThreshold || this._onStartReachedThreshold;
    const { layoutMeasurement, contentOffset } = e.nativeEvent;
    const distanceFromStart = contentOffset.y;
    if (onStartReached && this.hasDataChangedSinceStartReached && distanceFromStart < onStartThreshold * layoutMeasurement.height) {
      this.hasDataChangedSinceStartReached = false;
      onStartReached();
    }
  };

  _maybeCallScrollAtZero = e => {
    const { scrollAtZero, onScrollAtZeroThreshold } = this.props;
    const on_scroll_at_zero_threshold = onScrollAtZeroThreshold || this._onScrollAtZeroThreshold;
    if (scrollAtZero && this.hasDataChangedSinceScrollAtZero && e.nativeEvent.contentOffset.y < on_scroll_at_zero_threshold) {
      this.hasDataChangedSinceScrollAtZero = false;
      scrollAtZero();
    }
  };

  _scroll = event => {
    const { onScroll, scrollAtZero, onStartReached } = this.props;
    onScroll && onScroll(event);
    onStartReached && this._maybeCallOnStartReached(event);
    scrollAtZero && this._maybeCallScrollAtZero(event);
  };

  render() {
    const { data, myRef, scrollEventThrottle, onScroll, ...props } = this.props;
    return (
      <VirtualizedList
        scrollEventThrottle={scrollEventThrottle || this._scrollEventThrottle}
        ref={myRef}
        onScroll={this._scroll}
        data={data}
        getItemCount={() => data.length}
        {...props}
        getItem={(d, i) => d[i]}
      />
    );
  }
}

export const FlatList = List; // isWeb ? VirtualizedList : NativeList;



// WEBPACK FOOTER //
// ./src/components/core/flat_list.js